// extracted by mini-css-extract-plugin
export default {"detailsCard":"styles_detailsCard__2KtuQ","footer":"styles_footer__w5I92","detailsPivot":"styles_detailsPivot__VctG1","orderNumber":"styles_orderNumber__W-X5Q"};